import React from 'react';
import image1 from '../assets/image1.png';
import image2 from '../assets/image2.png';
import image3 from '../assets/image3.png';
import image4 from '../assets/image4.png';
import image5 from '../assets/image5.png';

// Custom styles for Partners component
const styles = `
.partners-section {
    background-color: white;
    padding: 40px 0;
    overflow: hidden;
}

.partners-container {
    position: relative;
    width: 100%;
    overflow: hidden;
}

.partners-track {
    display: flex;
    width: max-content;
    animation: scrollPartners 30s linear infinite;
}

.partner-logo-wrapper {
    flex-shrink: 0;
    padding: 0 40px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.partner-logo {
    max-height: 80px;
    width: auto;
    object-fit: contain;
    transition: transform 0.3s ease;
}

.partner-logo:hover {
    transform: scale(1.05);
}

@keyframes scrollPartners {
    0% {
        transform: translateX(0);
    }
    100% {
        transform: translateX(-50%);
    }
}

/* Responsive Styles */
@media (max-width: 1199.98px) {
    .partner-logo-wrapper {
        padding: 0 35px;
    }
    
    .partner-logo {
        max-height: 70px;
    }
}

@media (max-width: 991.98px) {
    .partners-section {
        padding: 35px 0;
    }
    
    .partner-logo-wrapper {
        padding: 0 30px;
    }
    
    .partner-logo {
        max-height: 65px;
    }
    
    .partners-track {
        animation-duration: 25s;
    }
}

@media (max-width: 767.98px) {
    .partners-section {
        padding: 30px 0;
    }
    
    .partner-logo-wrapper {
        padding: 0 25px;
    }
    
    .partner-logo {
        max-height: 55px;
    }
    
    .partners-track {
        animation-duration: 20s;
    }
}

@media (max-width: 575.98px) {
    .partners-section {
        padding: 25px 0;
    }
    
    .partner-logo-wrapper {
        padding: 0 20px;
    }
    
    .partner-logo {
        max-height: 50px;
    }
    
    .partners-track {
        animation-duration: 18s;
    }
}

@media (max-width: 400px) {
    .partners-section {
        padding: 20px 0;
    }
    
    .partner-logo-wrapper {
        padding: 0 15px;
    }
    
    .partner-logo {
        max-height: 45px;
    }
    
    .partners-track {
        animation-duration: 15s;
    }
}
`;

const Partners = () => {
    const logos = [
        { src: image1, alt: "Partner 1" },
        { src: image2, alt: "Partner 2" },
        { src: image3, alt: "Partner 3" },
        { src: image4, alt: "Partner 4" },
        { src: image5, alt: "Partner 5" },
    ];

    return (
        <>
            <style>{styles}</style>
            <section className="partners-section">
                <div className="partners-container">
                    <div className="partners-track">
                        {/* First set of logos */}
                        {logos.map((logo, index) => (
                            <div key={`first-${index}`} className="partner-logo-wrapper">
                                <img src={logo.src} alt={logo.alt} className="partner-logo" />
                            </div>
                        ))}
                        {/* Duplicate for seamless loop */}
                        {logos.map((logo, index) => (
                            <div key={`second-${index}`} className="partner-logo-wrapper">
                                <img src={logo.src} alt={logo.alt} className="partner-logo" />
                            </div>
                        ))}
                        {/* Third set for extra seamless scrolling */}
                        {logos.map((logo, index) => (
                            <div key={`third-${index}`} className="partner-logo-wrapper">
                                <img src={logo.src} alt={logo.alt} className="partner-logo" />
                            </div>
                        ))}
                        {/* Fourth set for extra seamless scrolling */}
                        {logos.map((logo, index) => (
                            <div key={`fourth-${index}`} className="partner-logo-wrapper">
                                <img src={logo.src} alt={logo.alt} className="partner-logo" />
                            </div>
                        ))}
                        {logos.map((logo, index) => (
                            <div key={`fifth-${index}`} className="partner-logo-wrapper">
                                <img src={logo.src} alt={logo.alt} className="partner-logo" />
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        </>
    );
};

export default Partners;
